import React from "react";
import FaultValues from "../../../component/Incident/FaultValues";

const FaultValuesScreen = () => {
  return (
    <div>
      <FaultValues />
    </div>
  );
};

export default FaultValuesScreen;
